import { Button, Skeleton } from '@heroui/react'
import { useWavesurfer } from '@wavesurfer/react'
import { Pause, PlayIcon } from 'lucide-react'
import { useRef } from 'react'

function AudioWaveform({ url, isLoading, waveColor = '#66AAF9', progressColor = '#CCE3FD' }) {
  const containerRef = useRef(null)

  const { wavesurfer, isReady, isPlaying } = useWavesurfer({
    container: containerRef,
    url,
    waveColor,
    height: 'auto',
    progressColor,
    cursorWidth: 2,
    cursorColor: '#1d4ed8',
    barWidth: 2,
    barGap: 2,
    barRadius: 2,
  })

  const onPlayPause = () => {
    wavesurfer && wavesurfer.playPause()
  }

  return (
    <div className={`
      relative flex h-24 rounded-sm border border-gray-200 bg-gray-50
    `}
    >
      <Button
        variant="flat"
        isIconOnly
        disableRipple
        size="md"
        color="primary"
        onPress={onPlayPause}
        radius="none"
        className="h-full"
      >
        {isPlaying
          ? <Pause size={16} />
          : <PlayIcon size={16} />}
      </Button>
      <div ref={containerRef} className="h-full w-full">
        {(!isReady || isLoading) && (
          <Skeleton className="absolute inset-0 h-24 w-full" />
        )}
      </div>
    </div>
  )
}

export default AudioWaveform
